import { toast } from 'sonner';

async function copyToClipboard(text: string) {
  try {
    await navigator.clipboard.writeText(text);
    toast.success('Copied to clipboard', { duration: 2000 });
  } catch (error) {
    console.error('Failed to copy error message:', error);
  }
}

export function displayAxiosError(errorMessage: string) {
  toast.error(errorMessage, {
    duration: 10000,
    action: {
      label: 'Copy',
      onClick: (event) => {
        event.preventDefault();
        copyToClipboard(errorMessage);
      },
    },
  });
}
